import { Component, OnInit,  EventEmitter, Output, Input, SimpleChanges  } from '@angular/core';
import { DadosPessoaisAba1 } from "../../service/dados-pessoais-aba1/dados-pessoais-aba1";
import { DadosPessoaisAba1Response } from "../../auth/_models/DadosPessoaisAba1";
import { EnumService } from 'app/service/enum/enum';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-recadastramento-aba2',
  templateUrl: './recadastramento-aba2.component.html',
  styleUrls: ['./recadastramento-aba2.component.sass']
})
export class RecadastramentoAba2Component implements OnInit {
  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  form: FormGroup;
  user: DadosPessoaisAba1Response = null;
  dataNascimento: string;
  uf: string;
  municipioNascimento: string;
  nacionalidade: string;
  pais: string;
  nomeMae: string;
  nomePai: string;
  isInfoImportantVisible: boolean = true;
  dadosPessoais: any
  constructor(
    private dadosPessoaisAba1: DadosPessoaisAba1,
    private enumService: EnumService,
    private dadosPessoaisService: DadosPessoaisAba1,
    private toasterService: ToastrService) {
  }

  ngOnInit(): void {
    this.obterDadosPessoais()
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));
   
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.mostrarAlerta) {
      this.isInfoImportantVisible = true
    }
  }
  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }
  obterDadosPessoais(): void {
    // Realize o GET novamente aqui

    this.dadosPessoaisService.getDadosPessoais().subscribe((dados) => {
      this.getDadosPessoias(dados);
    });
  }
  private getDadosPessoias(dados) {
    this.dataNascimento = dados.dataNascimento
    this.uf = dados.codUfNascimento
    this.municipioNascimento = dados.descricaoMunicipioNascimento
    this.nacionalidade  = dados.descricaoNacionalidade
    this.nomeMae = dados.nomeMae
    this.nomePai = dados.nomePai
    this.pais =  dados.descricaoPais 
  }
  avancaParaProximoTab() {
    this.dadosSalvos.emit()

  }
  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }
}